<template lang="pug">
    .card_container_dashboard(:id="id" :class="{'max-width': maxWidth, 'row': large, 'card_design': withStyle}")
      .card_title() {{ title }}
      .card_text.flex.left(v-if="!cash")
        span(:class="color" :id="id+'_text'") {{ text }}
      .card_amount.flex.left(v-if="cash")
        span(:class="color" :id="id+'_amount'") {{ amount | currency }} {{ currency }}
</template>

<script>
export default {
  name: 'CardResizeDashboard',
  props: {
    title: {
      default: 'Sample Card Text',
      type: String
    },
    text: {
      default: '',
      type: String | Number
    },
    amount: {
      default: 0,
      type: String | Number
    },
    cash: {
      default: true,
      type: Boolean
    },
    currency: {
      default: () => 'MXN',
      type: String
    },
    color: {
      default: '',
      type: String
    },
    id: {
      default: 'card_dashboard_1',
      type: String
    },
    large: {
      default: false,
      type: Boolean
    },
    maxWidth: {
      default: false,
      type: Boolean
    },
    withStyle: {
      default: true,
      type: Boolean
    }
  },
  watch: {
    amount () {
      this.resize()
    },
    text () {
      this.resize()
    }
  },
  mounted () {
    if (!this.large) this.resize()
  },
  methods: {
    resize () {
      if (!this.large) {
        setTimeout(() => {
          const container = document.getElementById(this.id)
          if (container != null) {
            const width = container.clientWidth
            var element = ''
            if (this.cash) {
              element = this.id + '_amount'
            } else {
              element = this.id + '_text'
            }
            const textElement = document.getElementById(element)
            textElement.style.cssText = 'font-size: 1vw'
            var fontSize = (width / (textElement.clientWidth * 1.5))
            fontSize = (fontSize < 1.4) ? 1.4 : (fontSize > 2.1) ? 2.1 : fontSize
            textElement.style.cssText = 'font-size: ' + fontSize + 'vw'
          }
        }, 100)
      }
    }
  }
}
</script>

<style lang="scss">
.card_container_dashboard {
  width: 95%;

  display: flex;
  flex-direction: column;
  align-items: left;
  justify-content: center;

  padding: 1rem 2rem 1rem 2rem;
}

.card_design {
  background-color: WHITE;
  min-height: 130px;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.1), 0 6px 20px 0 rgba(0, 0, 0, 0.05);
  border-radius: 20px;
}

.card_title {
  color: #595959;
  font-size: 18px;
  font-weight: 600;
}

.card_amount , .card_text  {
  font-weight: bold;
  width: 100%;
  min-height: 60px;
  max-height: 60px;
}

.row {
    width: 98.5%;
    display: flex;
    align-items: center;
    justify-content: left;
    gap: 5rem;
    flex-direction: row;

    .card_title {
        font-size: 2rem;
    }

    .card_text , .card_amount {
        span {
            font-size: 2vw;
            flex: 1;
            text-align: right;
        }
    }
}

.max-width {
    width: 97%;
}
</style>
